import React from "react"
import PropTypes from "prop-types"
import { Link } from "gatsby"

import TwitterIcon from "../images/twitter.svg"
import FacebookIcon from "../images/facebook.svg"
import InstagramIcon from "../images/instagram.svg"

const links = [
  { title: "home", link: "/" },
  { title: "portfolio", link: "/portfolio" },
  { title: "about", link: "/about" },
  { title: "blog", link: "/blog" },
  { title: "contact", link: "/contact" },
]

const icons = [TwitterIcon, FacebookIcon, InstagramIcon]

const Header = ({ siteTitle }) => (
  <header className="desktop flex justify-end items-center w-full my-10">
    <div className=" flex justify-between md:w-[36%]">
      {links.map(({ title, link }) => (
        <Link className="text-[14px] text-black" key={title} to={link}>
          {title}
        </Link>
      ))}
    </div>
    <div className="flex md:ml-[90px]">
      {icons.map(icon => (
        <Link
          className="mb-0 mr-[12px] last:mr-0 h-5 cursor-pointer"
          to="/code"
          key={icon}
        >
          <img className="m-0" width={20} src={icon} alt="social icons" />
        </Link>
      ))}
    </div>
  </header>
)

Header.propTypes = {
  siteTitle: PropTypes.string,
}

Header.defaultProps = {
  siteTitle: ``,
}

export default Header
